module.exports = "https://bin.bnbstatic.com/_next/static/images/blog-inner-bg-9536070e46800ce82a9dba1035fbf16f.jpg";